import { WalletContext } from "@/providers/wallet-context";
import { useContext } from "react";

export function useWallet() {
  const context = useContext(WalletContext);
  if (!context) {
    throw new Error("useWallet must be used inside WalletProvider");
  }

  return context;
}
